import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMonthlySalesTargets } from '@/hooks/api/0230_monthly_sales_targets';
import { useCurrentTeam } from '@/providers/TeamProvider';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MonthlySalesTargetElement } from '@/features/w/[identifier]/setting/teams/[team_id]/monthly_sales_targets/{components}/MonthlySalesTargetElement';
import { ScrollTop } from '@/components/element/ScrollTop';

export const MonthlySalesTargets = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('チーム売上目標編集'), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `チーム設定`, path: `/w/${_w_!.identifier}/setting/teams` },
        { label: `チーム詳細`, path: `/w/${_w_!.identifier}/setting/teams/${_t_!.id}` },
      ]),
    []
  );

  const navigate = useNavigate();
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();
  const { data } = useMonthlySalesTargets({ identifier: _w_!.identifier, team_id: _t_!.id });

  return (
    <WorkspaceLayout>
      <ScrollTop />
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'team'} />

        <div className="row">
          <div className="col-12 col-lg-12 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">チーム売上目標編集</h5>
                </div>
              </div>
              <form>
                <div className="card-body pt-0">
                  <div className="form-group">
                    <label>チーム名</label>
                    <p className="form-text text-muted text-sm ms-1">{_t_!.name}</p>
                  </div>
                  <hr className="horizontal dark mb-5" />
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="text-xs text-dark font-weight-bold mb-2">前期</div>
                      <div className="table-responsive">
                        <table className="table align-items-center">
                          <thead>
                            <tr>
                              <th
                                className="text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                style={{ width: 60 }}
                              >
                                対象年月
                              </th>
                              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                                売上目標
                              </th>
                              <th className="text-secondary opacity-7" style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.previous_sales_targets.map((d, i) => (
                              <MonthlySalesTargetElement key={`p-s-${i}`} monthlySalesTarget={d} />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="text-xs text-dark font-weight-bold mb-2">今期</div>
                      <div className="table-responsive">
                        <table className="table align-items-center">
                          <thead>
                            <tr>
                              <th
                                className="text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                style={{ width: 60 }}
                              >
                                対象年月
                              </th>
                              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                                売上目標
                              </th>
                              <th className="text-secondary opacity-7" style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.current_sales_targets.map((d, i) => (
                              <MonthlySalesTargetElement key={`c-s-${i}`} monthlySalesTarget={d} />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="text-xs text-dark font-weight-bold mb-2">来期</div>
                      <div className="table-responsive">
                        <table className="table align-items-center">
                          <thead>
                            <tr>
                              <th
                                className="text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                style={{ width: 60 }}
                              >
                                対象年月
                              </th>
                              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                                売上目標
                              </th>
                              <th className="text-secondary opacity-7" style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.next_sales_targets.map((d, i) => (
                              <MonthlySalesTargetElement key={`n-s-${i}`} monthlySalesTarget={d} />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                  <Link to="" className="btn btn-outline-secondary me-2" onClick={() => navigate(-1)}>
                    戻る
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
